<template>
    <div class="payment-content">
        <div class="text-title">
            <span>
                {{ payment.status === '1' ? 'Payment Detail' : 'Bill Detail' }}
            </span>
            Total
        </div>

        <div class="payment-detail">
            <span>
                <!-- {{ payment.updated_at }} -->
                {{ payment.status === '1' ? new Date(payment.payment_date).toLocaleString('en-US', {
                    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second:
                        '2-digit'
                }) : new
                    Date(payment.bill_date).toLocaleDateString('en-US') }}
            </span>
            ฿{{ parseInt(payment.price).toLocaleString('en-US') }}.00
        </div>
    </div>
</template>

<script>
export default {
    name: "Bill",
    props: ['payment'],
    data() {
        return {
            a: []
        }
    }
}
</script>

<style scoped lang="scss">
.payment-content {
    display: flex;
    flex-direction: column;
    border: 1px solid #8E8E8E;
    margin: 8px 0;
    padding: 12px 20px;
    border-radius: 16px;
    cursor: pointer;
    color: #686868;
}

.text-title {
    display: flex;
    justify-content: space-between;
    margin: 0;
    font-size: var(--font-mini);
}

.payment-detail {
    display: flex;
    font-size: var(--font-bigger);
    font-weight: 500;
    justify-content: space-between;
    margin: 0;
}
</style>